// Normalise a citation/source value into a safe external URL, or null.
// Upstream sometimes returns tokens like "inference" (not a link) or bare
// domains without a scheme (which would resolve as a dead relative path).
export function extSource(s) {
  if (!s || typeof s !== "string") return null;
  const v = s.trim();
  if (/^https?:\/\//i.test(v)) return v;
  if (/^[a-z0-9][a-z0-9-]*(\.[a-z0-9-]+)+(\/.*)?$/i.test(v)) return `https://${v}`;
  return null;
}

// True when a source value exists but is not a usable link (e.g. "inference"),
// meaning the fact came from our own assessment rather than a published page.
export function isAssessment(s) {
  if (!s || typeof s !== "string") return false;
  return !extSource(s.trim());
}
